import React, { ReactNode, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import AppContextPropsType from "../../types/AppContextPropsType";
import AppContext from "./AppContext";
import { matchRoutes } from "react-router-config";
import qs from "qs";
import { getUserEmail, useAuthToken } from "./AppHooks";
import { Loader } from "../index";
import { checkPermission } from "./Utils";
import { initialUrl } from "../../shared/constants/AppConst";
import { setAuthToken } from "@crema/services/ApiConfig";

import {
  NavStyle,
  ThemeMode,
  ThemeStyle,
} from "../../shared/constants/AppEnums";
import { ApolloClient, createHttpLink, gql, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

interface AuthRoutesProps {
  children: ReactNode;
}

const AuthRoutes: React.FC<AuthRoutesProps> = ({ children }) => {
  
  const newDa = useLocation();
  const { pathname, search } = useLocation();
  const { themeMode, updateAuthUser } = useContext<AppContextPropsType>(
    AppContext
  );

  const history = useHistory();
  const {
    routes,
    changeNavStyle,
    updateThemeStyle,
    initialPath,
    setInitialPath,
    updateThemeMode,
    setRTL,
  } = useContext<AppContextPropsType>(AppContext);


  const [loading, user] = useAuthToken();
  const fetchDataApi = (email:string,refreshToken:String) => {
    // console.log( "in auth in fetchDataApi;1")
    const apolloHttpLink1 = createHttpLink({
      uri: process.env.REACT_APP_API_URL,
    });
    const client1 = new ApolloClient({
      link: apolloHttpLink1.concat(apolloHttpLink1),
      cache: new InMemoryCache({
        addTypename: false,
      }),
    });
  
  
    
    return new Promise((resolve, reject) => {
      // console.log( "in auth before Promise;");
      client1
      .mutate({
        mutation: gql`
  mutation{
    refreshToken(
  resource:{
    resourceType:User,
    email:"${email}"
      refreshToken:"${refreshToken}"
  
  }){
    status
    message
    tokenresult
  }
  }
  
  
  `,
      })
      .then((result) => {
        // console.log( "in auth before Promise;");
          if(result !=null && result.data !=null  &&  result.data.refreshToken !=null && result.data.refreshToken.status==1){
          let tokenData =JSON.parse(result.data.refreshToken.tokenresult);
          let refreshToken = tokenData['refreshToken']['token'];
          let accesToken = tokenData['accessToken']['jwtToken'];
  
          let tokenExpiryDate = tokenData['accessToken']['payload']['exp'];
          localStorage.setItem("refreshToken", refreshToken);
              localStorage.setItem("accesToken", accesToken);
              localStorage.setItem("tokenExpiryDate", tokenExpiryDate);
              // console.log("refershtoken::",refreshToken)
          resolve(1);
  
        }else{
          // console.log( "in auth before else 0 ;");
          
          updateAuthUser(null);
          setAuthToken(null);
          if(pathname.split('/')[1] !==   "third-party-questionnaire" ){

            history.push("/login");
          }
         resolve(0);
          //logout user
        }
         //logout API goes Here
        
  
  
  
      });
  
      //add here
     
    });
  };
    const apolloAuthLink = setContext(async (request, { headers }) => {
      
      var now = new Date;
      var utc_timestamp = Date.UTC(now.getFullYear(),now.getMonth(), now.getDate() , 
            now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    
    //    const tokenEDate = new Date(1658840492);
    
    let currentTime =  Math.floor(utc_timestamp/1000)
    
    
      // get the authentication token from local storage if it exists
      let refreshToken='';
      let refreshTokenL = localStorage.getItem("refreshToken");
      if(refreshTokenL){
        refreshToken=refreshTokenL;
      }
      let accesToken = localStorage.getItem("accesToken");
      let tokenExpiryDate  = localStorage.getItem("tokenExpiryDate");
      if(tokenExpiryDate!=null && accesToken!=null)
      {
        let tokenExpiryDate1=parseInt(tokenExpiryDate);
        
    
        if(tokenExpiryDate1 > currentTime){
          // // console.log("in auth not expired");
          // token not expird
              }else{
    
                // console.log( "in auth before await change;")
                const loggedInEmail = getUserEmail();
    
                let getdata =await fetchDataApi(loggedInEmail,refreshToken);
                 accesToken = localStorage.getItem("accesToken");
                // console.log( "in auth after wawait;")
                //call refershToken
              }
      }
  
      
      return {
        headers: {
          ...headers,
          authorization: accesToken,
        },
      };
    });
  const apolloHttpLink = createHttpLink({
    uri: process.env.REACT_APP_API_URL,
  });
  
  const client = new ApolloClient({
    link: apolloAuthLink.concat(apolloHttpLink),
    cache: new InMemoryCache({
      addTypename: false,
    }),
  });
  const currentRoute = matchRoutes(routes, pathname)[0].route;
  let isPermitted = checkPermission(currentRoute.auth, user ? user.role : null);

  useEffect(() => {
    function setInitPath() {
      if (
        initialPath === "/" &&
        [
          "/signin",
          "/home",
          "/login",
          "/signup",
          "/verification",
          "/reset-password",
          "/error-pages/error-404",
          "/forget-password"
        ].indexOf(pathname) === -1
      ) {
        if (isPermitted) {
          setInitialPath(pathname);
        } else {
          setInitialPath(undefined);
        }
      }
    }

    setInitPath();
  }, [isPermitted, setInitialPath, initialPath, pathname]);

  useEffect(() => {
    function handleQueryParams() {
      const query = qs.parse(search.split("?")[1]);
      if (query.layout) {
        changeNavStyle(query.layout as NavStyle);
      }
      if (query.mode) {
        updateThemeMode(query.mode as ThemeMode);
      }
      if (query.rtl) {
        setRTL(true);
      }
      if (query.style) {
        updateThemeStyle!(query.style as ThemeStyle);
      }
    }

    if (search) {
      handleQueryParams();
    }
    const interval = setInterval(() => {
      let token = "";
      let AdminDetails = localStorage.getItem("AdminDetails");
      if (AdminDetails) {
        let userdetails = JSON.parse(AdminDetails);
        token = userdetails["id"];
      }

      // // console.log("token::", token);
      if (token != "") {
        client
          .query({
            query: gql`
          query {
            getUserStatus(_id: "${token}"){
              id
              accountStatus
              
            }
          }
        `,
          })
          .then((result) => {
            // // console.log("result::", result.data.getUserStatus.accountStatus);
            if (result.data.getUserStatus.accountStatus == 0) {
              // // console.log("Logs every 15 sec");
              localStorage.removeItem("token");
              //  localStorage.removeItem("token");
              localStorage.removeItem("AdminDetails");
              updateAuthUser(null);
              setAuthToken(null);
              if(pathname.split('/')[1] !==   "third-party-questionnaire" ){

                history.push("/login");
              }
           
            }
            // let practitionerList = result.data.PractitionerList;
          });
      }
    }, 10000);
  }, [changeNavStyle, updateThemeMode, setRTL, updateThemeStyle, search]);

  useEffect(() => {
    if (!loading) {
      let AdminDetails = localStorage.getItem("AdminDetails");
      let token = "";

      if (AdminDetails) {
        let userdetails = JSON.parse(AdminDetails);
        token = userdetails["identificationKey"];
      }

      /*
      if (!user && !isPermitted) {

        // console.log("before logoin1");
        history.push('/login'); // allowed route

      } else if (user && !isPermitted) {
        // console.log("before logoin2");
        history.push('/error-pages/error-404'); // Not found
      } else if (user && isPermitted) {
        // console.log("before logoin");
        if (
          pathname === '/' ||
          pathname === '/login' 
        ) {
          history.push(initialUrl);
        } else {
          // @ts-ignore
          if (
            initialPath &&
            initialUrl !== initialPath &&
            initialPath !== '/'
            // initialPath !== '/login' ||
            // initialPath !== '/signup')
          ) {
            history.push(initialPath);
          }
        }
      }*/

      if (!token) {
        // console.log(newDa,"before logoin1::", pathname.split('/'));

        if (
          pathname === "/login" ||
          pathname === "/reset-password" ||
          pathname === "/verification" ||
          pathname === "/forgot-password"||
          pathname.split('/')[1] ===   "third-party-questionnaire" 
        ) {
          history.push(pathname);
        } else {
          history.push("/login");
        }

        // allowed route
      } else if (token) {
        // console.log("before logoin::", initialPath);
        if (
          pathname === "/" ||
          pathname === "/login" ||
          pathname === "/reset-password" ||
          pathname === "/verification" ||
          pathname === "/forgot-password"||
          pathname.split('/')[1] ===   "third-party-questionnaire" 
        ) {
          if( pathname.split('/')[1] ===   "third-party-questionnaire" ){
            
            // setAuthToken(null)
            // localStorage.clear();
            history.push(pathname);
          }else{

            history.push(initialUrl);
          }
          // history.push(initialUrl);
        } else {
          // @ts-ignore
          if (
            initialPath &&
            initialUrl !== initialPath &&
            initialPath !== "/"
            // initialPath !== '/login' ||
            // initialPath !== '/signup')
          ) {
            history.push(initialPath);
          }
        }
      }
    }
  }, [user, loading, initialPath, isPermitted, pathname, history]);

  return loading ? <Loader /> : <>{children}</>;
};

export default AuthRoutes;
